var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M640 480H0V0h640z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#388d00",
  d: "M640 480H0V320h640z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d43516",
  d: "M640 160.1H0V.1h640z"
}))));
export { SvgHu as ReactComponent };
export default __webpack_public_path__ + "assets/images/hu.e404d718cffb5bd06467cbb60786edab.svg";